import React from 'react';
import PropTypes from 'prop-types';

const WelcomeMessage = ({ name }) => (
  <div id="search">
    <span className="text">
      Welcome, <b>{name}</b>
    </span>
  </div>
);

WelcomeMessage.displayName = 'WelcomeMessage';

WelcomeMessage.propTypes = {
  name: PropTypes.string.isRequired,
};

export default WelcomeMessage;
